module.exports = __webpack_public_path__ + "media/images/redesign-images/essentials/perfect/perfect-12-74318fdf3f7fb5e5bd2ffa97b5c210e2.jpg";